<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">订单编号</span>
            <el-input
                v-model="listQuery.no"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
           <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
                v-model="listQuery.businessNo"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">客户单号</span>
            <el-input
                v-model="listQuery.customerNo"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">所属公司</span>
            <el-select :filterable="true" v-model="listQuery.titleId" class="filter-item" placeholder="" @change="handleFilter" clearable remote :remote-method="getTitleOptionRemote" :size="t('table.btnSize')">
              <el-option
                v-for="item in titleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">客户公司</span>
            <el-input
                v-model="listQuery.customerCompany"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in getSalesManOptions()"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <!-- <div class="filter-box">
            <span class="label">订单状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div> -->
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">发起修改</span></span>
            <span class="status-item"><span class="status-square" style="background-color: #ffa217;"></span><span class="status-text">退回订单</span></span>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :handleDefaultWidth="80"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              :tableRowClassName="tableRowClassName"
              style="height:100% ;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  formPage="order"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="order"/>
              <BusinessInfo v-if="activeTab === 2" ref="TraceInfo" :id="activeId" api="order"/>
              <ChargeFee v-if="activeTab === 1" ref="ChargeFee" :id="activeId" api="order"/>
              <EngineerInfoList v-if="activeTab === 4" ref="EngineerInfoList" :id="activeId"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      :api="'order'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit"
    />
    <el-dialog
      v-model="submitStepsVisible"
      title="提示"
      width="40%"
    >
      <div v-for="(item, index) in stepsList" :key="index" style="display:flex;flex-flow:column">
        <span>第{{1}}步:</span>
        <span style="padding: 6px 10px;">{{item}}</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="submitStepsVisible = false;stepsList = []">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, ref, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { commitReview, regularOrder } from '@/apis/order'

import { UsersModel } from '@/model/userModel'

import { ArrayRowsItem, DropdownItem } from '@/model/Index'

import FormComponent from './From.vue'
import TableList from '@/components/common/TableList.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import BusinessInfo from './businessInfo/Index.vue'
import ChargeFee from '@/views/financial/chargeFee/Index.vue'

import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import { debounce } from 'lodash'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'
import EngineerInfoList from '@/views/business/businessList/engineerInfo/Index.vue'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Order',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    TraceInfo,
    BusinessInfo,
    ChargeFee,
    CommandRender,
    EngineerInfoList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_ORDER,
      permissionName: permissionName.ORDER,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      salesManOption: [],
      listQuery: {
        no: undefined,
        businessNo: undefined,
        customerNo: undefined,
        titleId: undefined,
        customerCompany: undefined,
        originator: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        salesManId: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      statusOption: [],
      titleOption: [],
      btnList: [],
      stepsList: [],
      submitStepsVisible: false,
      pageSizes,
      tabList: [
        { name: '业务信息', id: 2 }
        // { name: '收款明细', id: 1 },
        // { name: '工程师', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 2,

      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'commit':
            dataMap.handleCommit(val)
            break
          case 'order':
            dataMap.handleOrder(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList('order', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          businessNo: undefined,
          customerNo: undefined,
          titleId: undefined,
          customerCompany: undefined,
          originator: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          salesManId: undefined,
          ...pageVo

        }
        dataMap.handleFilter()
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      getSalesManOptions() {
        return dataMap.salesManOption
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        getUrlList(`order/${row.id}/actions/editable`).then(() => {
          dataMap.activeId = row.id
          dataMap.dialogFormVisible = true
        })
      },
      handleCommit(row: any) {
        ElMessageBox.confirm(
          '确定要提交选中数据吗？',
          '提交审批',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        ).then(() => {
          commitReview(row.id).then(() => {
            dataMap.getList()
            ElMessage({
              message: '提交成功',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      handleOrder(row: any) {
        ElMessageBox.confirm(
          '确定要提交选中数据吗？',
          '提交审批',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        ).then(() => {
          regularOrder(row.id).then(() => {
            dataMap.getList()
            ElMessage({
              message: '提交成功',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('order', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit(result: any) {
        if (result && !result.success) {
          dataMap.submitStepsVisible = true
          dataMap.stepsList = result.steps
          return
        }
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      // getDropdownList() {
      //   getUrlList('dropdown/OrderStatus').then((res: any) => {
      //     dataMap.statusOption = res || []
      //   })
      // },
      getTitleOptionRemote: debounce((query: string | number) => {
        getUrlList(`ticketTitle/dropdown?name=${query}`).then((res: any) => {
          dataMap.titleOption = res || []
        })
      }, 500),
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      tableRowClassName({ row }: any) {
        if (row.changeStatus == null) {
          return ''
        }
        switch (row.changeStatus) {
          case '发起修改':
            return 'row-red'
          case '退回':
            return 'row-orange'
          default:
            return ''
        }
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./order/Index',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    // 业务登记的时候故障描述叫改造功能需求
    onMounted(() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getTitleOptionRemote('')
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        }
      ]
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableListRef }
  }
})
</script>
<style  lang="scss">

</style>
